import React, { useEffect } from "react";

import { makeStyles, Theme } from "@material-ui/core/styles";
import {
  CircularProgress,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@material-ui/core";
import {
  Bar,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ComposedChart,
  ResponsiveContainer,
} from "recharts";
import { DateTime } from "luxon";
import { postRequest } from "../../../apis/axiosAction";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import {
  getKeieiShindanRegistedData,
  KEIEI_SHINDAN_BIG_RECORD,
  KEIEI_SHINDAN_DATA,
  KEIEI_SHINDAN_SCORE_DATA,
} from "./KeieiShindanDataOperation";
// import { stylesKeieiShindanTable } from "./StylesKeieiShindanRegister";
import { calculationTotalScore } from "./KeieiShindanCalculation";
import { userLogging } from "../../../apis/userLog";
import KeieiShindanDialog from "../KeieiShindanDialog";
import { selectUser } from "../../../features/userSlice";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme: Theme) => ({
  datePane: {
    backgroundColor: "lightgray",
    padding: 12,
  },
  firstRowCell: {
    [theme.breakpoints.down("md")]: {
      width: "3%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "2.9%",
    },
    padding: "6px 2px",
  },
  secondRowCell: {
    [theme.breakpoints.down("md")]: {
      width: "8%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "8%",
    },
    padding: "6px 1px",
    fontSize: "11px",
    fontWeight: "bold",
  },
  cell: {
    [theme.breakpoints.down("md")]: {
      width: "5%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "9.4%",
    },
    padding: "10px 5px",
    fontSize: "18px",
  },
  spaceCell: {
    [theme.breakpoints.down("md")]: {
      width: "4.5%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "4.5%",
    },
    padding: "0px",
  },
  totalColor: {
    color: "#82ca9d",
    fontSize: "20px",
  },
  score1Color: {
    color: "#8884d8",
    fontSize: "20px",
  },
  score2Color: {
    color: "green",
    fontSize: "20px",
  },
  score3Color: {
    color: "coral",
    fontSize: "20px",
  },
  score4Color: {
    color: "skyblue",
    fontSize: "20px",
  },
  score5Color: {
    color: "peru",
    fontSize: "20px",
  },
  score6Color: {
    color: "plum",
    fontSize: "20px",
  },
  score7Color: {
    color: "gold",
    fontSize: "20px",
  },
  score8Color: {
    color: "pink",
    fontSize: "20px",
  },
  customTooltip: {
    padding: "5px",
    border: "1px solid lightgray",
    backgroundColor: "rgba(255,255,255,0.9)",
    pointerEvents: "all",
    borderRadius: "5%",
  },
  customTooltipContent: {
    listStyle: "none",
  },
}));

// 小数点以下を四捨五入
const roundOffDecimal = (num: any) => {
  let value: number = Number(num);
  if (value) {
    return Math.round(value);
  }
  return 0;
};

const KeieiShindanResultGraphs: React.FC<{
  tenpoCode: string;
  keieiShindanId: string;
  lastKeieiShindanId: string;
}> = ({ tenpoCode, keieiShindanId, lastKeieiShindanId }) => {
  const user = useSelector(selectUser);
  const classes = useStyles();
  // const stylesClasses = stylesKeieiShindanTable();

  const [approvalDate, setApprovalDate] = React.useState<DateTime | null>(null);
  const [dataMapList, setdataMapList] = React.useState<any[]>([]);
  // TODO zoCode,taragetDateの初期値を設定
  const [tenpCcode] = React.useState("");
  const [targetDate] = React.useState("");
  const [activeTooltip, setActiveTooltip] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const [dialogMessage, setDialogMessage] = React.useState<any[]>([]);
  const [dialogFlg, setDialogFlg] = React.useState(false);

  // ダイアログ表示
  const dialogOK = () => {
    setDialogFlg(false);
  };
  // 検索実行処理
  useEffect(() => {
    setLoading(true);
    userLogging("店舗経営診断", "集計#初期表示", keieiShindanId);
    getKeieiShindanRegistedData(tenpoCode, keieiShindanId).then(
      (res: KEIEI_SHINDAN_DATA) => {
        let appDate = res.approve_day
          ? DateTime.fromFormat(res.approve_day, "yyyyMMdd")
          : DateTime.local();
        setApprovalDate(appDate);
        const apiParams = {
          "api-name": "summary",
          target_date: appDate.toLocaleString() + " 00:00:00",
          tenpo_code: tenpoCode,
        };

        // 当週分の計算
        const rowItemList: KEIEI_SHINDAN_BIG_RECORD[] = res.rows;
        const scoreData: KEIEI_SHINDAN_SCORE_DATA = res.score_data;

        interface LOCAL_SCORE {
          maxScore: number;
          score: number;
        }
        function getThisMonthData() {
          let data001 = { maxScore: 0, score: 0 };
          let data002 = { maxScore: 0, score: 0 };
          let data003 = { maxScore: 0, score: 0 };
          let data004 = { maxScore: 0, score: 0 };
          let data005 = { maxScore: 0, score: 0 };
          let resultData: any = {};
          let percentScore = 0;
          resultData["total"] = calculationTotalScore(rowItemList);

          if (scoreData && scoreData.scores) {
            for (let i = 0; i < scoreData.scores.length; i++) {
              let itemScore = Number(scoreData.scores[i].score);
              let maxScore = Number(scoreData.scores[i].max_score);
              if (scoreData.scores[i].no === "1") {
                setScore(data001, itemScore, maxScore);
              }
              if (scoreData.scores[i].no === "2") {
                setScore(data002, itemScore, maxScore);
              }
              if (scoreData.scores[i].no === "3") {
                setScore(data003, itemScore, maxScore);
              }
              if (scoreData.scores[i].no === "4") {
                setScore(data004, itemScore, maxScore);
              }
              if (scoreData.scores[i].no === "5") {
                percentScore = Number(scoreData.scores[i].minus_per_score);
                data005.score = itemScore;
              }
            }
          }

          resultData["score001"] = calcScore(data001);
          resultData["score002"] = calcScore(data002);
          resultData["score003"] = calcScore(data003);
          resultData["score004"] = calcScore(data004);
          resultData["score005"] = percentScore;
          resultData["real_score1"] = data001.score;
          resultData["real_score2"] = data002.score;
          resultData["real_score3"] = data003.score;
          resultData["real_score4"] = data004.score;
          resultData["real_score5"] = data005.score;
          resultData["max_score1"] = data001.maxScore;
          resultData["max_score2"] = data002.maxScore;
          resultData["max_score3"] = data003.maxScore;
          resultData["max_score4"] = data004.maxScore;
          resultData["max_score5"] = data005.maxScore;
          return resultData;
        }

        function setScore(
          scoreObj: LOCAL_SCORE,
          score: number,
          maxScore: number
        ) {
          scoreObj.maxScore += maxScore;
          scoreObj.score += score;
        }
        function calcScore(scoreObj: LOCAL_SCORE) {
          if (scoreObj.maxScore === 0) {
            return 0;
          }
          return Math.round((scoreObj.score / scoreObj.maxScore) * 100);
        }

        const url = process.env.REACT_APP_API_URL_J11SPB22 + "keieishindan/summary";
        postRequest(url, apiParams)
          .then((res) => {
            let dataList: any[] = res.data.dataList;

            let thisMonthDate: any = getThisMonthData();
            if (dataList) {
              for (let i = 0; i < dataList.length; i++) {
                var m = parseInt(dataList[i].month.substr(5, 2));
                var d = parseInt(dataList[i].month.substr(7, 2));
                var dt = m + "/" + d;
                dataList[i].month = dt;
                if (i === 0) {
                  dataList[i].total = thisMonthDate.total;
                  dataList[i].score001 = thisMonthDate.score001;
                  dataList[i].real_score1 = thisMonthDate.real_score1;
                  dataList[i].max_score1 = thisMonthDate.max_score1;
                  dataList[i].score002 = thisMonthDate.score002;
                  dataList[i].real_score2 = thisMonthDate.real_score2;
                  dataList[i].max_score2 = thisMonthDate.max_score2;
                  dataList[i].score003 = thisMonthDate.score003;
                  dataList[i].real_score3 = thisMonthDate.real_score3;
                  dataList[i].max_score3 = thisMonthDate.max_score3;
                  dataList[i].score004 = thisMonthDate.score004;
                  dataList[i].real_score4 = thisMonthDate.real_score4;
                  dataList[i].max_score4 = thisMonthDate.max_score4;
                  dataList[i].score005 = thisMonthDate.score005;
                  dataList[i].real_score5 = thisMonthDate.real_score5;
                  dataList[i].max_score5 = thisMonthDate.max_score5;
                }
                dataList[i].total = roundOffDecimal(
                  dataList[i].total
                ).toLocaleString(undefined, { maximumFractionDigits: 2 });
                dataList[i].score001 = roundOffDecimal(
                  dataList[i].score001
                ).toLocaleString(undefined, { maximumFractionDigits: 2 });
                dataList[i].score002 = roundOffDecimal(
                  dataList[i].score002
                ).toLocaleString(undefined, { maximumFractionDigits: 2 });
                dataList[i].score003 = roundOffDecimal(
                  dataList[i].score003
                ).toLocaleString(undefined, { maximumFractionDigits: 2 });
                dataList[i].score004 = roundOffDecimal(
                  dataList[i].score004
                ).toLocaleString(undefined, { maximumFractionDigits: 2 });
                dataList[i].score005 = roundOffDecimal(
                  dataList[i].score005
                ).toLocaleString(undefined, { maximumFractionDigits: 2 });
                dataList[i].real_score1 = Number(dataList[i].real_score1);
                // dataList[i].max_score1 = dataList[i].max_score1;
                dataList[i].real_score2 = Number(dataList[i].real_score2);
                // dataList[i].max_score2 = dataList[i].max_score2;
                dataList[i].real_score3 = Number(dataList[i].real_score3);
                // dataList[i].max_score3 = dataList[i].max_score3;
                dataList[i].real_score4 = Number(dataList[i].real_score4);
                // dataList[i].max_score4 = dataList[i].max_score4;
                dataList[i].real_score5 = Number(dataList[i].real_score5);
                // dataList[i].max_score5 = dataList[i].max_score5;
              }
              dataList.reverse();
              setdataMapList(dataList);
            }
          })
          .catch((r) => {
            userLogging(
              "店舗確認表",
              "集計#初期表示エラー",
              keieiShindanId + " " + JSON.stringify(r)
            );
            setDialogMessage([String(r)]);
            setDialogFlg(true);
          })
          .finally(() => {
            setLoading(false);
          });
      }
    );
  }, [tenpCcode, targetDate]);

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length && activeTooltip) {
      return (
        <div className={classes.customTooltip}>
          <div style={{ textAlign: "right" }}>
            <IconButton onClick={() => setActiveTooltip(false)} size={"small"}>
              <HighlightOffIcon />
            </IconButton>
          </div>
          <li className={classes.customTooltipContent}>{`${label}`}</li>
          {payload.map((payload: any, index: any) => {
            let newName = "";
            let color;
            switch (payload.name) {
              case "total":
                newName = "合計";
                color = "#82ca9d";
                break;
              case "score001":
                newName = "基本四原則";
                color = "#8884d8";
                break;
              case "score002":
                newName = "従業員募集・定着";
                color = "green";
                break;
              case "score003":
                newName = "体制強化";
                color = "coral";
                break;
              case "score004":
                newName = "行為計画";
                color = "skyblue";
                break;
              case "score005":
                newName = "労使関連 遵守事項";
                color = "skyblue";
                break;
            }
            return (
              <li
                className={classes.customTooltipContent}
                style={{ color: color }}
                key={index.toString()}
              >
                {newName +
                  "：" +
                  new Intl.NumberFormat("en").format(payload.value) +
                  "%"}
              </li>
            );
          })}
        </div>
      );
    }
    return null;
  };

  const handleActiveTooltip = () => {
    setActiveTooltip(true);
  };

  // ReactStrinctModeでエラーが出ているけどいったん保留 React.StrictMode → React.Fragment にすれば直る
  return (
    <Grid container justify="center">
      {/* {loading && <div className={stylesClasses.overLayer}></div>} */}
      {loading && (
        <CircularProgress
          // className={stylesClasses.circularProgress}
          size={120}
        />
      )}
      <Grid container item xs={12} justify="center">
        <Grid container item xs={12} justify="flex-start">
          <Typography color="textSecondary" gutterBottom>
            ▼個店数値
          </Typography>
        </Grid>
        <Grid container item xs={12} justify="flex-start">
          <>
            <ResponsiveContainer height={400}>
              <ComposedChart
                data={dataMapList}
                margin={{ top: 30, right: 0, bottom: 5, left: 80 }}
              >
                <CartesianGrid stroke="#f5f5f5" />
                <XAxis
                  dataKey="month"
                  scale="band"
                  label={{
                    value: "(月)",
                    dx: 50,
                    position: "insideBottomRight",
                  }}
                />
                <YAxis
                  yAxisId={1}
                  domain={[0, 100]}
                  tickCount={5}
                  label={{
                    value: "(合計)",
                    position: "insideTopLeft",
                    dy: -30,
                  }}
                />
                <YAxis
                  yAxisId={2}
                  orientation="right"
                  domain={[0, 100]}
                  tickCount={5}
                  tickFormatter={(tickItem) => tickItem + "%"}
                  label={{
                    value: "(得点率)",
                    position: "insideTopLeft",
                    dy: -30,
                  }}
                />
                <Tooltip trigger="click" content={<CustomTooltip />} />
                <Bar
                  dataKey="total"
                  barSize={20}
                  fill="#82ca9d"
                  yAxisId={1}
                  onClick={() => {
                    handleActiveTooltip();
                  }}
                />
                <Line
                  type="linear"
                  dataKey="score001"
                  stroke="#8884d8"
                  yAxisId={2}
                  onClick={() => {
                    handleActiveTooltip();
                  }}
                />
                <Line
                  type="linear"
                  dataKey="score002"
                  stroke="green"
                  yAxisId={2}
                  onClick={() => {
                    handleActiveTooltip();
                  }}
                />
                <Line
                  type="linear"
                  dataKey="score003"
                  stroke="coral"
                  yAxisId={2}
                  onClick={() => {
                    handleActiveTooltip();
                  }}
                />
                <Line
                  type="linear"
                  dataKey="score004"
                  stroke="skyblue"
                  yAxisId={2}
                  onClick={() => {
                    handleActiveTooltip();
                  }}
                />
              </ComposedChart>
            </ResponsiveContainer>
          </>
        </Grid>
        <Grid container item xs={12} justify="flex-start">
          <Table aria-label="a dense table">
            <TableBody>
              <TableRow>
                <TableCell className={classes.firstRowCell}>
                  <span className={classes.totalColor}>●</span>
                </TableCell>
                <TableCell className={classes.secondRowCell} align="left">
                  合計(100点満点)
                </TableCell>
                {dataMapList.map((data: any, index: number) => (
                  <TableCell
                    className={classes.cell}
                    align="center"
                    key={index.toString()}
                  >
                    {data.total}点
                  </TableCell>
                ))}
                <TableCell className={classes.spaceCell}>　</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.firstRowCell}>
                  <span className={classes.score1Color}>●</span>
                </TableCell>
                <TableCell className={classes.secondRowCell} align="left">
                  基本四原則(30点満点)
                </TableCell>
                {dataMapList.map((data: any, index: number) => (
                  <TableCell
                    className={classes.cell}
                    align="center"
                    key={index.toString()}
                  >
                    {data.real_score1}点[{data.score001}%]
                  </TableCell>
                ))}
                <TableCell className={classes.spaceCell}>　</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.firstRowCell}>
                  <span className={classes.score2Color}>●</span>
                </TableCell>
                <TableCell className={classes.secondRowCell} align="left">
                  従業員募集・定着(24点満点)
                </TableCell>
                {dataMapList.map((data: any, index: number) => (
                  <TableCell
                    className={classes.cell}
                    align="center"
                    key={index.toString()}
                  >
                    {data.real_score2}点[{data.score002}%]
                  </TableCell>
                ))}
                <TableCell className={classes.spaceCell}>　</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.firstRowCell}>
                  <span className={classes.score3Color}>●</span>
                </TableCell>
                <TableCell className={classes.secondRowCell} align="left">
                  体制強化(24点満点)
                </TableCell>
                {dataMapList.map((data: any, index: number) => (
                  <TableCell
                    className={classes.cell}
                    align="center"
                    key={index.toString()}
                  >
                    {data.real_score3}点[{data.score003}%]
                  </TableCell>
                ))}
                <TableCell className={classes.spaceCell}>　</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.firstRowCell}>
                  <span className={classes.score4Color}>●</span>
                </TableCell>
                <TableCell className={classes.secondRowCell} align="left">
                  行為計画(22点満点)
                </TableCell>
                {dataMapList.map((data: any, index: number) => (
                  <TableCell
                    className={classes.cell}
                    align="center"
                    key={index.toString()}
                  >
                    {data.real_score4}点[{data.score004}%]
                  </TableCell>
                ))}
                <TableCell className={classes.spaceCell}>　</TableCell>
              </TableRow>

              <TableRow>
                <TableCell className={classes.firstRowCell}>
                  <span className={classes.score5Color}>●</span>
                </TableCell>
                <TableCell className={classes.secondRowCell} align="left">
                  労使関連 遵守事項 (0点満点)
                </TableCell>
                {dataMapList.map((data: any, index: number) => (
                  <TableCell
                    className={classes.cell}
                    align="center"
                    key={index.toString()}
                  >
                    {data.real_score5}点[{data.score005}%]
                  </TableCell>
                ))}
                <TableCell className={classes.spaceCell}>　</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>
      </Grid>
      {/* ダイアログ */}
      <KeieiShindanDialog
        msg={dialogMessage}
        isOpen={dialogFlg}
        doOK={dialogOK}
        doNo={dialogOK}
        isAlert={true}
      />
    </Grid>
  );
};

export default KeieiShindanResultGraphs;
